<!--
 * @Descripttion: 个人中心-办事大厅
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-11 10:50:59
-->
<template>
    <div>
        <div class="offer-title">
            <div>
                <span>办事大厅</span>
                <span class="more" @click="openHrPortal">查看更多</span>
            </div>
        </div>
        <div class="offer-center">
            <div class="offer-center-right">
                <div :class="['offer-center-left', { 'user-guide-staff-box': steps.step4 }]" @click="openHrPortal">
                    <div class="offer-center-left-title">
                        <div class="text">
                            员工服务办事大厅
                        </div>
                        <span class="line"></span>
                    </div>
                    <div class="offer-center-left-text">
                        <span>一站式线上办事大厅，员工服务触手可及。</span>
                    </div>
                </div>
                <div class="offer-center-right-item">
                    <div class="offer-center-right-item-text">
                        <span>常用应用</span>
                    </div>
                    <div class="offer-center-right-item-app">
                        <div
                            v-for="(item, index) in dataList"
                            :key="index"
                            class="offer-center-right-item-apps"
                            @click="openHrPortal"
                        >
                            <div class="offer-center-right-item-apps-img">
                                <img :src="item.url" alt="" />
                            </div>

                            <div>
                                <span>{{ item.title }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="offer-bottom">
            <!-- <span>查看更多</span> -->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "UserCenterInfo",
    data() {
        return {
            dataList: [
                {
                    title: "证明开具",
                    url: require("@/assets/pics/user-center/xz1.png"),
                },
                {
                    title: "转正申请",
                    url: require("@/assets/pics/user-center/zzsq.png"),
                },
                {
                    title: "教育深造福利申报",
                    url: require("@/assets/pics/user-center/jyszfl.png"),
                },
            ],
        };
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    methods: {
        openHrPortal() {
            window.open(this.$config.hrUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.offer-title {
    height: 50px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;

    div {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        .more {
            cursor: pointer;
        }
    }
}
.offer-center {
    border-bottom: 1px solid #e1e2e3;
    display: flex;
    padding-bottom: 20px;
    margin: 0px 20px 0px 20px;

    .offer-center-right {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .offer-center-left {
            flex: 1;
            height: 146px;
            background: #e6fbfb;
            border-radius: 4px;
            padding: 30px 0px 0px 20px;
            background-image: url("../../../../assets/pics/user-center/grbsdt.png");
            background-position-x: center;
            background-position-y: center;
            background-size: 100% 100%;
            cursor: pointer;
            &.user-guide-staff-box {
                position: relative;
                z-index: 999;
                background-color: #fff;
                border-radius: 8px;
                border: 2px solid #3a9d80;
                pointer-events: none;
            }
            .offer-center-left-title {
                display: inline-block;
                font-size: 22px;
                position: relative;
                margin-bottom: 20px;
                .text {
                    z-index: 2;

                    font-size: 20px;
                    font-weight: 500;
                    color: #333333;
                }
                .line {
                    z-index: 1;
                    bottom: 5px;
                    display: inline-block;
                    position: absolute;
                    width: 100%;
                    left: 0;
                    opacity: 0.3;
                    border-bottom: 6px solid #3a9d80;
                }
            }
            .offer-center-left-text {
                width: 68%;
                line-height: 18px;
            }
        }
        .offer-center-right-item {
            flex: 1;
            margin-left: 20px;
            height: 146px;
            border-radius: 4px;
            border: 1px solid #e1e2e3;
            .offer-center-right-item-text {
                padding-top: 24px;
                padding-left: 20px;
                margin-bottom: 20px;
            }
            .offer-center-right-item-app {
                display: flex;
                justify-content: space-around;

                .offer-center-right-item-apps {
                    width: 86px;
                    text-align: center;
                    cursor: pointer;
                    .offer-center-right-item-apps-img {
                        margin-bottom: 12px;
                        img {
                            width: 32px;
                            height: 32px;
                        }
                    }
                }
            }
        }
    }
}
.offer-bottom {
    height: 43px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    cursor: pointer;
}
</style>
